/**
 * Created by chenzheyu on 2017/6/14.
 */
import XKimgcode from './src/imgCode.vue'

XKimgcode.intall = function (Vue) {
  Vue.component(XKimgcode.name, XKimgcode)
}

export default XKimgcode



// WEBPACK FOOTER //
// ./src/components/module/imgCode/index.js